import React from "react"
import Modal from "react-bootstrap/Modal"
import JoinForm from "./joinForm"

import styles from "../../styles/components/landing/joinModal.module.scss"
import bgImage from "../../images/landing/background-lines.svg"

const JoinModal = props => {
  return (
    <Modal
      show={props.show}
      onHide={props.close}
      dialogClassName={styles.container}
      centered
    >
      <Modal.Header className={styles.header} closeButton></Modal.Header>
      <Modal.Body style={{ padding: 0 }}>
        <div
          className={styles.content}
          style={{ backgroundImage: `url("${bgImage}")` }}
        >
          <h1 className={styles.title}>Sign Up Today</h1>
          <p className="small em">Change your life in 3 months</p>
          <JoinForm />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default JoinModal
